export default __webpack_public_path__ + "static/media/home.00ad2fea.png";